import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import React from 'react';
import ReactLoading from "react-loading";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import {
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from 'reactstrap';
import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import { getCollectionList } from "../../actions/kafairAction";
import { doFilteringSearchToApi, fetchCollectionProduct, getRecommendedProduct } from '../../actions/productAction';
import { getQueryParamsUrl } from "../../helpers/url";
import DrawerBack from "../../images/drawerBack.png";
import expressShippingIcon from "../../images/express-shipping.png";
import { categoryURL } from '../../utils';
import { genderSearchPage, sneakersCondition, sneakersConditionUrl, sneakersConditionValue } from '../../utils/Helpers';
import ColorPicker from './ColorPicker';
import { CATEGORY_LIST, GENDER_LIST, SNEAKERS_CONDITION_BRAND_PAGE, SNEAKERS_CONDITION_LUXURY } from './Resources/Data';

/*
type Funct = (any:any, any2:any, any3:any) => void
type Props = {
  dataProduct:Object,
  dataFilter:Object, 
  doFilteringSearchToApi:Funct,
  history:Object,
  match:Object,
}
type State = {
  activeSize: string,
  selectedBrands: Array<number>,
  selectedSizes: Object,
  sneakers_condition:string  
}
*/

const styles = {
  click: {
    cursor: 'pointer'
  }
}

const PER_PAGE_DEFAULT = 52;

const SizeButton = ({ data, selectSize, isSelectedSize, getSizeButtonClass }) => {
  return (
    <Row className="size-row">
      {
        data.map(d => {
          return (
            <Col key={d.id} className="size-column">
              {/* <Button block className={classNames("flat spacer bolder small-button", this.getSizeButtonClass(size.id))} onClick={()=>this.selectSize(size)}>{size.US}</Button> */}
              <Button
                key={d.id}
                onClick={() => selectSize(d)}
                active={() => isSelectedSize(d.id)}
              // className={classNames("flat spacer bolder small-button", getSizeButtonClass(d.id))}
              >
                {d.US}
              </Button>
            </Col>
          )
        })
      }
    </Row>
  )
}

const Loader: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ marginTop: 16, display: isVisible ? 'flex' : 'none' }}
    >
      <Col>
        <ReactLoading type={'spin'} height={50} width={50} color={'#159953'} />
      </Col>
    </Row>
  );
};

class FilterDrawer extends React.Component {
  constructor(props) {
    super(props);
    let { brands } = this.props.dataFilter;
    let femaleSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.femaleSizes.noDuplicate : [];
    let maleSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.maleSizes.noDuplicate : [];
    let kidSizes = this.props.dataFilter.sizes ? this.props.dataFilter.sizes.kidsSizes : []

    this.state = {
      activeSize: 'maleSizes',
      activeApparelsSize: 'topSizes',
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: [],
        apparelSizes: [],
      },
      userCurrency: {
        currency: 'IDR',
        ratio: 1
      },
      endPrice: '',
      startPrice: '',
      isBrandExpanded: false,
      isChildBrandExpanded: false,
      isSizeExpanded: false,
      isConditionExpanded: false,
      isPriceExpanded: false,
      sneakers_condition: '',
      sex: '',
      color: '',
      searchCategory: '',
      _activeTabSize: 1,
      // collectionButton: '',
      isFetchingBrands: false,
      isFetchingSize: true,
      newBrands: '',
      newCategories: '',
      newSneakersConditions: '',
      newHandbagsConditions: '',
      newGender: '',
      newSizes: '',
      allCategory: CATEGORY_LIST,
      allSneakersCondition: props.history.location.pathname.split('/')[1] !== 'luxury' ? SNEAKERS_CONDITION_BRAND_PAGE : SNEAKERS_CONDITION_LUXURY,
      allBrand: brands,
      allGender: GENDER_LIST,
      // allSize: maleSizes,
      femaleSizeList: femaleSizes,
      maleSizeList: maleSizes,
      kidSizeList: kidSizes,
    };
    this.handleFilter = this.handleFilter.bind(this);
    this.isSelected = this.isSelected.bind(this);
  }

  componentDidMount() {
    let { startPrice, endPrice, searchCategory } = this.props;
    const { isHotProductsPage, isMostPopularPage, isBestSellingPage } = this.props;
    this.setState({ startPrice, endPrice, searchCategory });

    // Handle for default selected filters
    const params = getQueryParamsUrl(this.props.history.location.search);
    const { sneakersCondition, colours, sex } = params;

    if (sneakersCondition) {
      this.setState({ sneakers_condition: sneakersCondition });
    }
    if (colours) {
      this.setState({ color: colours });
    }
    if (sex) {
      this.setState({ sex })
    }

    this.getListMadeIndo();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { dataAuth } = this.props
    const params = getQueryParamsUrl(this.props.history.location.search);
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.props;
    if (dataAuth.isLogged && dataAuth.userCurrency.isFetch !== prevProps.dataAuth.userCurrency.isFetch) {
      this.setState({ userCurrency: dataAuth.userCurrency })
    }

    if (prevProps.isOpen !== this.props.isOpen) {
      const { sneakers_condition, startPrice, endPrice, sex, color, searchCategory } = this.state;
      const category = this.props.match.params.category;

      //CATEGORY FOR API REQUEST
      const newCategory = ["streetwear", "fashion", "apparel"].includes(category) ? "apparels" : ["luxury", "handbags"].includes(category) ? "handbags" : ["lifestyle", "toys", "electronics-collectibles"].includes(category) ? "lifestyles" : category;
      const queryCategory = {
        params: {
          category: newCategory
        }
      }

      if (this.props.isOpen) {
        if (isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage) {
          this.setState({
            searchCategory: categoryURL(params.category),
          });
        }
      }

      const { path } = this.props.match;
      const slug = path && path.slice(11);

      this.setState({
        sneakers_condition: params.sneakersCondition ? params.sneakersCondition : "",
        startPrice: params.startPrice ? params.startPrice : "",
        endPrice: params.endPrice ? params.endPrice : "",
        sex: params.sex ? params.sex : "",
        color: params.colours ? params.colours : "",
        searchCategory: category ? category : "",
      });
    }

    // Handle for updating the filter drawer to latest filter state based on parent component
    if (prevProps.sex !== this.props.sex) {
      this.setState({
        sex: this.props.sex,
      });
    }
    if (prevProps.sneakers_condition !== this.props.sneakers_condition) {
      this.setState({
        sneakers_condition: this.props.sneakers_condition,
      });
    }
    if ((prevProps.searchCategory !== this.props.searchCategory) && (!isHotProductsAllCategoryPage && !isTrendingPage && !isBestSellingAllCategoryPage && !isPriceDropPage)) {
      this.setState({
        searchCategory: this.props.searchCategory,
      });
    }
    if (prevProps.startPrice !== this.props.startPrice) {
      this.setState({
        startPrice: this.props.startPrice,
      });
    }
    if (prevProps.endPrice !== this.props.endPrice) {
      this.setState({
        endPrice: this.props.endPrice,
      });
    }
    if (prevProps.color !== this.props.color) {
      this.setState({
        color: this.props.color,
      });
    }

    // handle product aggregations
    if (prevProps.productAggregations !== this.props.productAggregations) {
      this.updateProductAggregations();
    }
  }

  updateProductAggregations() {
    const { brands, categories, conditions, gender, sizes } = this.props.productAggregations;

    let isEmpty = Object.keys(this.props.productAggregations).length === 0;
    const convert = (item) => {
      return Object.keys(item).map(name => ({ name }));
    }

    this.setState({
      newCategories: isEmpty ? this.state.allCategory : convert(categories),
      newSneakersConditions: isEmpty ? this.state.allSneakersCondition : convert(conditions),
      newBrands: isEmpty ? this.state.allBrand : convert(brands),
      newGender: isEmpty ? this.state.allBrand : convert(gender),
      newSizes: isEmpty ? this.state.femaleSizeList : convert(sizes),
    })
  }

  // handle position of sneakers on the first line
  repositionCategory = (array) => {
    let removedSneakers = array && array.filter(item => {
      return item.name !== "sneakers";
    })

    let arrSneakers = array && array.find(item => item.name === "sneakers");

    let addedSneakers = removedSneakers && removedSneakers.unshift(arrSneakers);

    let isSneakers = array && array.some(arr => arr['name'] === 'sneakers');

    let newCategoryList = isSneakers ? removedSneakers : addedSneakers;

    return newCategoryList;
  }

  getListMadeIndo = () => {
    if (!this.props.isMadeIndonesia) return
    let payload = {
      availables: true,
      per_page: 11,
      page: 1,
    };

    this.props.getCollectionList('all', 'madeindonesia', payload, 'madeindonesia')
      .then((res) => res.data)
  }

  onChangeHandler = (e) => {
    const key = e.target.name
    let val = e.target.value;
    if (isNaN(+val)) return;
    this.updateState(key, val);
  }

  isSelected(selected) {
    const { selectedBrands } = this.state;
    const item = selectedBrands?.find((a) => a === selected.toString());
    return item !== undefined && item !== null;
  }

  getButtonClass = (key, val) => {
    let value = this.state[key];
    if (this.state[key] === 'apparels') {
      value = 'apparel';
    } else if (this.state[key] === 'handbags') {
      value = 'luxury'
    } else if (this.state[key] === 'lifestyles') {
      value = 'electronics-collectibles'
    }
    return value === val ? 'btn-black' : 'btn-white'
  }

  updateState = (key, val, unselectable = false, callback = () => { }) => {
    if (!unselectable) {
      this.setState({ [key]: val }, callback);
    } else {
      if (this.state[key] === val && key === 'searchCategory') {
        this.setState({
          selectedSizes: {
            maleSizes: [],
            femaleSizes: [],
            kidSizes: [],
            apparelSizes: [],
          },
        });
      }
      this.setState({
        [key]: this.state[key] === val ? '' : val //clear if the value is already selected
      }, callback)
    }
  }

  dolarToRupiah = (price) => {
    return Math.round(parseFloat(price) / this.state.userCurrency.ratio)
  }

  handleFilter = () => {
    const { selected } = this.props.dataCategory;
    const { pathname } = this.props.history.location
    const { searchKeyword, caseSorting } = this.props.dataProduct;
    const { startPrice, endPrice, sneakers_condition, sex, color, searchCategory } = this.state;
    const params = getQueryParamsUrl(this.props.history.location.search);

    const categoryURL = searchCategory === "apparels" ? "apparel" : searchCategory === "handbags" ? "luxury" : searchCategory === "lifestyles" ? "electronics-collectibles" : searchCategory;

    const categoryParams = ["lifestyle", "toys", "electronics-collectibles"].includes(searchCategory) ? "lifestyles" : searchCategory;

    const newPathName = searchCategory ? `/${categoryURL}` : "/browse-all";

    let startPriceCon = startPrice
    let endPriceCon = endPrice

    if ((startPrice || endPrice) && this.state.userCurrency.currency !== 'IDR') {
      startPriceCon = this.dolarToRupiah(startPrice)
      endPriceCon = this.dolarToRupiah(endPrice)
    }

    let filterQueries = '';
    let filterQueriesConverted = '';
    let queries = []
    if (startPrice) queries.push({ keyword: 'start_price', value: startPrice })
    if (endPrice) queries.push({ keyword: 'end_price', value: endPrice })
    if (sneakers_condition) queries.push({ keyword: 'sneakers_condition', value: sneakers_condition })
    if (sex) queries.push({ keyword: 'sex', value: sex })
    if (color) queries.push({ keyword: 'colours', value: color })

    if (queries.length) {
      queries.map((q) => {
        if (q.keyword) {
          if (q.keyword === 'start_price' || q.keyword === 'end_price') {
            filterQueries += `${q.keyword}=${q.value}&`
            filterQueriesConverted += `${q.keyword}=${q.keyword === 'start_price' ? startPriceCon : endPriceCon}&`
          } else {
            filterQueries += `${q.keyword}=${q.value}&`
            filterQueriesConverted += `${q.keyword}=${q.value}&`
          }
        } else {
          filterQueries += q.value
          filterQueriesConverted += q.value
        }
      })
    }

    if (filterQueries.length || filterQueriesConverted.length) {
      if (filterQueries.charAt(filterQueries.length - 1) === '&') {
        filterQueries = filterQueries.substr(0, filterQueries.length - 1)
      }
      if (filterQueriesConverted.charAt(filterQueriesConverted.length - 1) === '&') {
        filterQueriesConverted = filterQueriesConverted.substr(0, filterQueriesConverted.length - 1)
      }
      filterQueries.replace('&&', '&')
      filterQueriesConverted.replace('&&', '&')
    }

    const newFilterQueries = filterQueries.replace('pre_verified', 'express_shipping');

    this.props.history.push({ pathname: this.props.history.location.pathname, search: newFilterQueries });

    if (window.innerWidth <= 655) {
      this.props.onClose()
    }

    this.props.onSaveLastState(sneakers_condition, startPrice, endPrice, sex, color, searchCategory)
  }

  resetFilter = () => {
    if (this.props.categoryOnly) {
      this.props.history.push(this.props.history.location.pathname);
      this.props.onClose();
      return;
    }

    const { selected } = this.props.dataCategory;
    const { caseSorting } = this.props.dataProduct;
    const { isCollectionPage, isForYou } = this.props;
    const pathname = this.props.location && this.props.location.pathname;
    const isCategory = pathname.search(categoryURL(selected));

    this.setState({
      startPrice: "",
      endPrice: "",
      sneakers_condition: "",
      sex: "",
      color: "",
      brands: "",
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: [],
        apparelSizes: [],
      },
      selectedBrands: []
    }, () => {
      if (window.innerWidth <= 655) {
        this.props.onClose()
      }

      const newPathname = `/collection/${this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length - 1]}`;

      const removeCategory = (isCategory > 0) ? `${newPathname}` : `${pathname}`;

      this.props.doFilteringSearchToApi('', {
        params: {
          page: 1,
          availables: true,
          category: isCollectionPage || isForYou ? selected : "",
          per_page: PER_PAGE_DEFAULT,
          sort_by: caseSorting
        }
      }, '')
      this.props.history.push({
        pathname: isCollectionPage ? removeCategory : `/browse-all`,
        search: ''
      })
    })
  }

  applyFilter = () => {
    const { searchCategory } = this.state;
    if (this.props.isTrendingPage) {
      this.props.history.push(`/trending?category=${categoryURL(searchCategory)}`);
      this.props.onClose();
      return;
    }

    if (this.props.isHotProductsAllCategoryPage) {
      this.props.history.push(`/hot-products?category=${categoryURL(searchCategory)}`);
      this.props.onClose();
      return;
    }

    if (this.props.isPriceDropPage) {
      this.props.history.push(`/price-drop?category=${categoryURL(searchCategory)}`);
      this.props.onClose();
      return;
    }

    if (this.props.isBestSellingAllCategoryPage) {
      this.props.history.push(`/best-selling?category=${categoryURL(searchCategory)}`);
      this.props.onClose();
      return;
    }
    if (this.props.isCollectionPage) {
      this.handleCollectionFilter();
    } else if (this.props.isForYou) {
      this.handleForYouFilter();
    } else {
      this.handleFilter();
    }
  }

  _renderNewConditions = () => {
    const { selected } = this.props.dataCategory;
    const { category } = this.props.match.params;
    const { allSneakersCondition } = this.state;

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Conditions</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="condition-wrapper">
          <Row className="condition-sneaker">
            {
              allSneakersCondition && allSneakersCondition.map((item) => {
                return (
                  <div className="condition-button">
                    <Button block className={classNames("flat spacer", this.getButtonClass("sneakers_condition", sneakersConditionUrl(sneakersConditionValue(item.name))))} onClick={() => this.updateState("sneakers_condition", sneakersConditionUrl(sneakersConditionValue(item.name)), true)}>{sneakersCondition(item.name)}  {
                      (item.name === "PREVERIFIED") ? <KickImage src={expressShippingIcon} alt="express shipping" style={{ width: "8px", height: "12px" }} /> : null
                    }</Button>
                  </div>
                )
              })
            }
          </Row>
        </Col>
      </Row>
    )
  }

  _renderNewGender = () => {
    let { allGender } = this.state;
    return (
      <Row style={{ alignSelf: "flex-start" }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Gender</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="condition-wrapper">
          <Row className="condition-sneaker">
            {
              allGender && allGender.map((item) => {
                return (
                  <div className="condition-button">
                    <Button block className={classNames("flat spacer", this.getButtonClass("sex", item.name))} onClick={() => this.updateState("sex", item.name, true, () => this.applyFilter())}>{genderSearchPage(item.name)}</Button>
                  </div>
                )
              })
            }
          </Row>
        </Col>
      </Row>
    )
  }

  _toggle = (tabs) => {
    if (this.state._tabs !== tabs)
      this.setState({
        _activeTabSize: tabs
      })
  }

  handleChangeColor = (value) => {
    this.updateState("color", value, true)
  };

  _renderNewColor = () => {
    return (
      <Row style={{ marginBottom: "10px", alignSelf: "flex-start" }}>

        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Color</p>
            </Col>
          </Row>
        </Col>

        <Col xs={12}>
          <Row>
            <Col>
              <ColorPicker
                onClick={this.handleChangeColor}
                isActive={this.state.color}
              />
            </Col>
          </Row>
        </Col>

      </Row>
    )
  }

  _renderNewPrice = () => {
    const auth = this.props.dataAuth
    const userCurrency = auth.isLogged && auth.userCurrency

    return (
      <Row style={{ marginBottom: 20 }}>
        <Col xs={12}>
          <Row>
            <Col md={6} xs={8}>
              <p className="title">Price Range</p>
            </Col>
          </Row>
        </Col>
        <Col xs={12} style={{ marginBottom: 16 }}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{userCurrency ? userCurrency.currency : 'IDR'}</InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Minimum Price"
              name="startPrice"
              value={this.state.startPrice}
              onChange={this.onChangeHandler}
              inputMode='numeric'
            />
          </InputGroup>
        </Col>

        <Col xs={12}>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{userCurrency ? userCurrency.currency : 'IDR'}</InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Maximum Price"
              name="endPrice"
              value={this.state.endPrice}
              onChange={this.onChangeHandler}
              inputMode='numeric'
            />
          </InputGroup>
        </Col>
      </Row>
    )
  }

  render() {
    const { selected } = this.props.dataCategory;
    const { searchCategory } = this.props;
    const { category } = this.props.match.params;
    if (!this.props.isOpen) return null;

    return (
      // <div id={'filter-dropdown'} className="container__drop_down show__option filter__dropdown__wrapper">
      <div id="filter-drawer__v3">
        <div className="drawer-content">
          <div onClick={() => this.props.onClose()} className='back-navigation'>
            <Row>
              <Col>
                <span><KickImage src={DrawerBack} alt="back to filter" /></span>
              </Col>
              <Col>
                <p>Filter</p>
              </Col>
            </Row>
          </div>
          {!["lifestyle", "toys", "electronics-collectibles"].includes(category) && !this.props.categoryOnly && this._renderNewGender()}
          {this._renderNewConditions()}
          {!["lifestyle", "toys", "electronics-collectibles"].includes(category) && !this.props.categoryOnly && this._renderNewColor()}
          {this._renderNewPrice()}

        </div>
        <Row className="action-button">
          <Col className="button-filter reset" lg={6} md={6} sm={6} xs={6}>
            <Button
              block
              size="lg"
              className="btn-black flat spacer"
              onClick={this.resetFilter}
              disabled={(searchCategory === "") && (this.state.selectedBrands ?? [].length === 0) && (this.state.startPrice === "") && (this.state.endPrice === "") && (this.state.sex === "") && (this.state.color === "") && (this.state.sneakers_condition === "")}
            >Clear Filters</Button>
          </Col>
          <Col className="button-filter apply" lg={6} md={6} sm={6} xs={6}>
            <Button
              block
              size="lg"
              className="btn-black flat spacer"
              onClick={this.applyFilter}
              disabled={(searchCategory === "") && (this.state.selectedBrands ?? [].length === 0) && (this.state.startPrice === "") && (this.state.endPrice === "") && (this.state.sex === "") && (this.state.color === "") && (this.state.sneakers_condition === "")}
            >Apply Filter</Button>
          </Col>
        </Row>
      </div>
      // </div>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct,
  dataFilter: state.filterReducer,
  dataLocal: state.dataKaFair.local_brands
});
const mapDispatchToProps = {
  doFilteringSearchToApi,
  fetchCollectionProduct,
  getAllBrands,
  getAllSizes,
  getRecommendedProduct,
  getCollectionList
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilterDrawer));